import {ReactElement, ReactNode} from "react";
import {StyledContainer} from "@/shared/StyledComponents";
import {Button, ButtonProps, useTheme} from "@mui/material";
import {BORDER_RADIUS_XLARGE, PD_MD, PD_XLG2} from "@/shared/dimens";

export function LargeButton(props: ButtonProps): ReactElement {
  const theme = useTheme();
  return <Button {...props} style={{
    fontSize: "100%",
    padding: `${PD_MD}px ${PD_XLG2}px`,
    border: "1px solid " + theme.palette.primary.contrastText,
    borderRadius: BORDER_RADIUS_XLARGE, ...props.style
  }}/>
}

export function SectionContainer(props: { children?: ReactNode, style?: any }): ReactElement {
  return <StyledContainer style={{padding: "4%", ...props.style}}>
    {props.children}
  </StyledContainer>
}